const studyPaths = [
  {
    id: 'clerk-mvp',
    title: 'Clerk Preparation (MVP)',
    description: 'Seeded MVP path for Clerk exam — 3 subjects with topics and previous papers.',
    estimatedHours: 120,
  },
  {
    id: 'ssc-mvp',
    title: 'SSC General Awareness (Preview)',
    description: 'A quick path to start practicing general awareness and reasoning.',
    estimatedHours: 80,
  },
];

export default studyPaths;
